import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import ParserImage from "./ParserImage";
import SpinnerLoading from '../sampanganimation/SpinnerLoading';
import axios from "axios";
import Swal from "sweetalert2";
import Guest from "./middleware/Guest";
import { Toast } from 'primereact/toast';
import OTPComponent from "./OTPComponent";

import "./assets/themify-icon/themify-icons.css";
import "./assets/simple-line-icon/simple-line-icons.css";
import "./assets/font-awesome/css/all.css";
import "./assets/elagent/style.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./assets/animate.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/main.css";
import "./assets/responsive.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "./assets/custom.css";
import "primereact/resources/themes/lara-light-cyan/theme.css"

const LoginPage = (props) => {
    const [hide, setHide] = useState(true);
    const [isOTP, setIsOTP] = useState(false);
    const [isResend, setIsResend] = useState(false);
    const [users, setUsers] = useState([]);
    const [fadeIn, setFadeIn] = useState(false);
    const toast = useRef(null);

    const [formData, setFormData] = useState({
        username: '',
        otp_mode: 'whatsapp',
    });

    useEffect(() => {
        props.hideloader();
        ParserImage();

        // Trigger fade in animation
        setTimeout(() => {
            setFadeIn(true);
        }, 100);
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        SpinnerLoading(true);

        axios
            .post(global.config.backend + "/api/login", formData)
            .then((res) => {

                SpinnerLoading(false);

                if (res.data.status) {
                    // Fade out login form
                    setFadeIn(false);
                    setTimeout(() => {
                        setIsOTP(true);
                        setUsers(res.data.data);
                        setFadeIn(true);
                    }, 300);

                    if (isResend)
                        toast.current.show({ severity: 'success', detail: 'OTP Telah di kirim Ulang' });
                }

                if (!res.data.status) {
                    if (Array.isArray(res.data.errors)) {
                        if (res.data.errors.length > 0) {
                            res.data.errors.map((item) => {
                                toast.current.show({ severity: 'warn', detail: item });
                            });
                        } else {
                            toast.current.show({ severity: 'warn', detail: res.data.message });
                        }
                    } else {
                        // const errorData = JSON.parse(res.data.errors);
                        // if (Array.isArray(errorData.error.messages)) {
                        //     errorData.error.messages.map((item) => {
                        //         toast.current.show({ severity: 'warn', detail: item });
                        //     });
                        // } else {
                            toast.current.show({ severity: 'warn', detail: res.data.message });
                        // }
                    }
                }
            })
            .catch((res) => {
                console.log(res);
                SpinnerLoading(false);
                toast.current.show({ severity: 'warn', detail: 'Error connect to services' });
            });
    };

    const handleResend = (e) => {
        setIsResend(true)
        handleSubmit(e)
    }

    const animationStyles = `
        /* Modern Login Styles */
        .modern-background {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100vh;
            z-index: -1;
            overflow: hidden;
        }

        .background-image {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-size: cover;
            background-position: center;
            filter: blur(8px) brightness(0.7);
            transform: scale(1.1);
            transition: all 0.8s ease;
        }

        .background-overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            // background: linear-gradient(135deg, rgba(0, 68, 170, 0.9) 0%, rgba(0, 36, 97, 0.9) 100%);
            background: linear-gradient(135deg, rgb(0 68 170 / 28%) 0%, rgb(0 36 97 / 33%) 100%);
            z-index: 1;
        }

        .login-container {
            min-height: 100vh;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 20px;
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.5s ease;
        }

        .login-container.fade-in {
            opacity: 1;
            transform: translateY(0);
        }

        .login-container.fade-out {
            opacity: 0;
            transform: translateY(-20px);
        }

        .login-wrapper {
            width: 100%;
            max-width: 420px;
            z-index: 2;
        }

        /* Logo Section */
        .logo-section {
            text-align: center;
            margin-bottom: 40px;
            animation: float 6s ease-in-out infinite;
        }

        .logo-wrapper {
            width: 120px;
            height: 120px;
            margin: 0 auto 20px;
            padding: 20px;
            background: rgba(255, 255, 255, 0.1);
            backdrop-filter: blur(10px);
            border-radius: 50%;
            border: 2px solid rgba(255, 255, 255, 0.2);
            transition: all 0.3s ease;
        }

        .logo-wrapper:hover {
            transform: scale(1.05);
            border-color: rgba(255, 255, 255, 0.4);
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
        }

        .logo-image {
            width: 100%;
            height: 100%;
            object-fit: contain;
            filter: brightness(0) invert(1);
        }

        .department-title {
            color: white;
            font-size: 28px;
            font-weight: 600;
            margin-bottom: 0px;
            letter-spacing: 1px;
            text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
        }

        .department-subtitle {
            color: rgba(255, 255, 255, 0.8);
            font-size: 16px;
            font-weight: 300;
            letter-spacing: 2px;
        }

        /* Login Card */
        .login-card {
            background: rgba(255, 255, 255, 0.95);
            backdrop-filter: blur(20px);
            border-radius: 24px;
            padding: 40px;
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
            border: 1px solid rgba(255, 255, 255, 0.3);
            transform: translateY(0);
            opacity: 1;
            transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .login-card.card-enter {
            animation: cardEnter 0.6s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .login-card.card-exit {
            opacity: 0;
            transform: translateY(30px);
        }

        .card-header {
            text-align: center;
            margin-bottom: 32px;
            background: transparent;
        }

        .card-title {
            line-height: normal;
            color: #002461;
            font-size: 32px;
            font-weight: 700;
            margin-bottom: 8px;
            background: linear-gradient(135deg, #04a, #002461);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }

        .card-subtitle {
            margin-top: 0;
            color: #666;
            font-size: 14px;
            font-weight: 400;
            line-height: normal;
        }

        /* Form Styles */
        .login-form {
            margin-bottom: 24px;
        }

        .form-group {
            margin-bottom: 24px;
        }

        .input-wrapper {
            position: relative;
        }

        .input-icon {
            position: absolute;
            left: 16px;
            top: 50%;
            transform: translateY(-50%);
            color: #04a;
            font-size: 18px;
            z-index: 1;
        }

        .modern-input {
            width: 100%;
            padding: 16px 16px 16px 48px;
            background: rgba(255, 255, 255, 0.9);
            border: 2px solid rgba(4, 170, 255, 0.2);
            border-radius: 12px;
            font-size: 16px;
            color: #333;
            transition: all 0.3s ease;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
        }

        .modern-input:focus {
            outline: none;
            border-color: #04a;
            box-shadow: 0 4px 20px rgba(4, 170, 255, 0.2);
            transform: translateY(-1px);
        }

        .modern-input::placeholder {
            color: #999;
        }

        .input-label {
            display: block;
            margin-bottom: 12px;
            color: #555;
            font-size: 14px;
            font-weight: 600;
        }

        /* OTP Mode Selector */
        .otp-mode-selector {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 12px;
        }

        .mode-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            padding: 16px;
            background: rgba(255, 255, 255, 0.9);
            border: 2px solid rgba(0, 0, 0, 0.1);
            border-radius: 12px;
            color: #666;
            font-size: 14px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.3s ease;
        }

        .mode-btn:hover {
            border-color: rgba(4, 170, 255, 0.3);
            transform: translateY(-2px);
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        }

        .mode-btn.active {
            background: linear-gradient(135deg, #04a, #002461);
            border-color: transparent;
            color: white;
            box-shadow: 0 4px 20px rgba(4, 170, 255, 0.3);
        }

        .mode-btn i {
            font-size: 18px;
        }

        /* Button Styles */
        .modern-btn {
            width: 100%;
            padding: 10px;
            border: none;
            border-radius: 12px;
            font-size: 16px;
            font-weight: 600;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 12px;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            position: relative;
            overflow: hidden;
        }

        .modern-btn::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 0;
            height: 0;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.2);
            transform: translate(-50%, -50%);
            transition: width 0.6s, height 0.6s;
        }

        .modern-btn:hover::before {
            width: 300px;
            height: 300px;
        }

        .modern-btn.primary {
            background: linear-gradient(135deg, #04a, #05c, #04a, #002461);
            color: white;
            box-shadow: 0 8px 25px rgba(4, 170, 255, 0.3);
        }

        .modern-btn.primary:hover {
            transform: translateY(-3px);
            box-shadow: 0 15px 35px rgba(4, 170, 255, 0.4);
        }

        /* Card Footer */
        .card-footer {
            text-align: center;
            padding-top: 24px;
            border-top: 1px solid rgba(0, 0, 0, 0.1);
            background: transparent;
        }

        .copyright {
            color: #888;
            font-size: 12px;
            font-weight: 300;
        }

        /* Animations */
        @keyframes float {
            0%, 100% {
                transform: translateY(0);
            }
            50% {
                transform: translateY(-10px);
            }
        }

        @keyframes cardEnter {
            0% {
                opacity: 0;
                transform: translateY(30px) scale(0.95);
            }
            100% {
                opacity: 1;
                transform: translateY(0) scale(1);
            }
        }

        @keyframes fadeIn {
            from {
                opacity: 0;
                transform: translateY(20px);
            }
            to {
                opacity: 1;
                transform: translateY(0);
            }
        }

        /* Responsive Design */
        @media (max-width: 768px) {
            .login-wrapper {
                max-width: 100%;
                // padding: 20px;
            }

            .login-card {
                padding: 30px 24px;
            }

            .logo-wrapper {
                width: 100px;
                height: 100px;
            }

            .department-title {
                font-size: 24px;
            }

            .card-title {
                font-size: 28px;
            }
        }

        @media (max-width: 480px) {
            .otp-mode-selector {
                grid-template-columns: 1fr;
            }

            .login-card {
                padding: 24px 20px;
            }

            .modern-btn {
                padding: 10px;
            }
        }
    `

    return (
        <>
            <Toast ref={toast} />

            {/* Modern Background with gradient overlay */}
            <div className="modern-background">
                <div className="background-overlay"></div>
                <div className="background-image"
                    style={{
                        backgroundImage: 'url(https://api-gateway.sampangkab.go.id/be-kominfo/sampanganimation/api/getimage/L2Fzc2V0cy91cGxvYWQvaW1hZ2VzL2JhY2tncm91bmQvYmdzc2QzLW1pbi5wbmc=)',
                    }}>
                </div>
            </div>

            <section className={`login-container ${fadeIn ? 'fade-in' : 'fade-out'}`}>
                <div className="login-wrapper">
                    {/* Logo Section */}
                    <div className="logo-section">
                        <div className="logo-wrapper">
                            <img
                                src="/assets/upload/images/template_image/kominfo.png"
                                alt="logo Kominfo"
                                className="logo-image"
                            />
                        </div>
                        <h1 className="department-title">DINAS KOMINFO</h1>
                        <p className="department-subtitle">Kabupaten Sampang</p>
                    </div>

                    {/* Content Section */}
                    <div className="content-section">
                        {!isOTP ? (
                            <div className={`login-card ${fadeIn ? 'card-enter' : 'card-exit'}`}>
                                <div className="card-header">
                                    <h2 className="card-title">Login</h2>
                                    <p className="card-subtitle">Masukkan username Anda</p>
                                </div>

                                <form className="login-form" onSubmit={handleSubmit}>
                                    <div className="form-group">
                                        <div className="input-wrapper">
                                            <i className="ti-user input-icon"></i>
                                            <input
                                                type="text"
                                                name="username"
                                                value={formData.username}
                                                onChange={handleChange}
                                                className="modern-input"
                                                placeholder="Username"
                                                required
                                                autoFocus
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="input-label">Pilih pengiriman OTP</label>
                                        <div className="otp-mode-selector">
                                            <button
                                                type="button"
                                                className={`mode-btn ${formData.otp_mode === 'whatsapp' ? 'active' : ''}`}
                                                onClick={() => setFormData({ ...formData, otp_mode: 'whatsapp' })}
                                            >
                                                <i className="fab fa-whatsapp"></i>
                                                <span>WhatsApp</span>
                                            </button>
                                            <button
                                                type="button"
                                                className={`mode-btn ${formData.otp_mode === 'telegram' ? 'active' : ''}`}
                                                onClick={() => setFormData({ ...formData, otp_mode: 'telegram' })}
                                            >
                                                <i className="fab fa-telegram"></i>
                                                <span>Telegram</span>
                                            </button>
                                        </div>
                                        <button
                                            type="button"
                                            className={`mode-btn w-100 mt-3 ${formData.otp_mode === 'system' ? 'active' : ''}`}
                                            onClick={() => setFormData({ ...formData, otp_mode: 'system' })}
                                        >
                                            <i className="fa fa-cogs"></i>
                                            <span>System</span>
                                        </button>
                                    </div>

                                    <div className="form-group">
                                        <button type="submit" className="modern-btn primary">
                                            <span>Kirim OTP</span>
                                            <i className="ti-arrow-right"></i>
                                        </button>
                                    </div>
                                </form>

                                <div className="card-footer">
                                    <p className="copyright mb-0">
                                        {new Date().getFullYear()} &copy; Dinas Kominfo Sampang
                                    </p>
                                </div>
                            </div>
                        ) : (
                            <OTPComponent
                                length={6}
                                users={users}
                                onResend={handleResend}
                                className={fadeIn ? 'card-enter' : 'card-exit'}
                            />
                        )}
                    </div>
                </div>
            </section>
            <style>{animationStyles}</style>
        </>
    );
};

export default Guest(LoginPage);